import React, { memo, useMemo } from 'react'
import { Mic, MicOff } from '@mui/icons-material'

import useUserMicrophone from '@tabeeb/modules/presentation/hooks/useUserMicrophone'
import { VideoCallUser } from '@tabeeb/modules/../users/types'
import UserActionButton from '../UserActionButton'

interface MuteUserAudioButtonProps {
  user: VideoCallUser
}

const MuteUserAudioButton: React.FC<MuteUserAudioButtonProps> = ({ user }) => {
  const { handleClick, isPresenter, currentUserId, isMuted } = useUserMicrophone({ user, enableHotkey: true })

  const icon = useMemo(() => {
    return isMuted ? MicOff : Mic
  }, [isMuted])

  return (
    <UserActionButton
      icon={icon}
      title={isMuted ? 'Unmute microphone' : 'Mute microphone'}
      disabled={!isPresenter && currentUserId !== user.id}
      isMuted={isMuted}
      onClick={handleClick}
    />
  )
}

export default memo(MuteUserAudioButton)
